var React = require('react');
import Divider from './Divider';
var TextArea = require('./TextArea');
import TextBox from './TextBox';
var DropDown = require('./DropDown');

var PersonalData = React.createClass({
    getInitialState: function() {
        return {
            firstname: '',
            surname: '',
            gender: '',
            birth: '',
            email: '',
            confirmEmail: '',
            address: '',
            zipcode: '',
            city: '',
            country: '',
            phone: '',
            other: ''
        }
    },
    changeField: function(change) {
        var isValid = false;
        switch(change.id) {
            case 'confirmEmail':
                isValid = this.refs[change.id].validate(change.newValue, this.state.email);
                break;
            case 'email':
                isValid = this.refs[change.id].validate(change.newValue, this.state.confirmEmail);
                break;
            default:
                isValid = this.refs[change.id].validate(change.newValue)
        }
        
        var field = {};
        field[change.id] = change.newValue;
        this.setState(field, function () {
            this.handleChange();
        });
    },
    render: function () {
        var genderOptions = [
            { label: 'Choose gender', value: '' },
            { label: 'Male', value: 'male' },
            { label: 'Female', value: 'female' }
        ];
        return (
            <div>
                <Divider value={5} label="Personal data" />
                <div className="j-row">
                    <div className="span6 unit">
                        <TextBox
                            id="firstname"
                            ref="firstname"
                            enabled={true}
                            onChange={this.changeField}
                            placeholder="First name"
                            value={this.state.firstname}
                            icon="fa-user" />
                    </div>
                    <div className="span6 unit">
                        <TextBox
                            id="surname"
                            ref="surname"
                            enabled={true}
                            onChange={this.changeField}
                            placeholder="Surname"
                            value={this.state.surname}
                            icon="fa-user" />
                    </div>
                </div>
                <div className="j-row">
                    <div className="span6 unit">
                        <DropDown id="gender"
                                  ref="gender"
                                  options={genderOptions}
                                  value={this.state.gender}
                                  onChange={this.changeField}
                                  visible={true}
                        />
                    </div>
                    <div className="span6 unit">
                        <TextBox
                            id="birth"
                            ref="birth"
                            enabled={true}
                            validator={/^\d{4}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])$/}
                            onChange={this.changeField}
                            placeholder="Date of Birth"
                            value={this.state.birth}
                            icon="fa-birthday-cake"
                            help="&nbsp;format: yyyymmdd f.e. 19790118" />
                    </div>
                </div>

                <div className="j-row">
                    <div className="span6 unit">
                        <TextBox
                            id="email"
                            ref="email"
                            enabled={true}
                            validator={/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/}
                            onChange={this.changeField}
                            placeholder="E-mail"
                            value={this.state.email}
                            icon="fa-envelope-o" />
                    </div>

                    <div className="span6 unit">
                        <TextBox
                            id="confirmEmail"
                            ref="confirmEmail"
                            enabled={true}
                            validator={/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/}
                            onChange={this.changeField}
                            placeholder="Confirm e-mail"
                            value={this.state.confirmEmail}
                            icon="fa-envelope-o" />
                    </div>
                </div>

                <div className="unit">
                    <TextBox
                        id="address"
                        ref="address"
                        enabled={true}
                        onChange={this.changeField}
                        placeholder="Address"
                        value={this.state.address}
                        icon="fa-building-o" />
                </div>

                <div className="j-row">
                    <div className="span4 unit">
                        <TextBox
                            id="zipcode"
                            ref="zipcode"
                            enabled={true}
                            onChange={this.changeField}
                            placeholder="Zip code"
                            value={this.state.zipcode}
                            icon="fa-bookmark-o" />
                    </div>
                    <div className="span8 unit">
                        <TextBox
                            id="city"
                            ref="city"
                            enabled={true}
                            onChange={this.changeField}
                            placeholder="City"
                            value={this.state.city}
                            icon="fa-building-o" />
                    </div>
                </div>

                <div className="j-row">
                    <div className="span6 unit">
                        <TextBox
                            id="country"
                            ref="country"
                            enabled={true}
                            onChange={this.changeField}
                            placeholder="Country"
                            value={this.state.country}
                            icon="fa-flag" />
                    </div>
                    <div className="span6 unit">
                        <TextBox
                            id="phone"
                            ref="phone"
                            enabled={true}
                            onChange={this.changeField}
                            placeholder="Phone"
                            value={this.state.phone}
                            icon="fa-phone" />
                    </div>
                </div>
                <div className="j-row">
                    <div className="unit span12">
                        <TextArea
                            id="other"
                            ref="other"
                            enabled={true}
                            onChange={this.changeField}
                            placeholder="your message..."
                            value={this.state.other}
                            icon="fa-file-text-o" />
                    </div>

                </div>
            </div>
        );
    },
    handleChange: function() {
        this.props.onChange({
            person: {
                firstname: this.state.firstname,
                surname: this.state.surname,
                gender: this.state.gender,
                birth: this.state.birth,
                email: this.state.email,
                address: this.state.address,
                zipcode: this.state.zipcode,
                city: this.state.city,
                country: this.state.country,
                phone: this.state.phone,
                other: this.state.other
            }
        });
    },
    validate: function() {
        var validFirstname = this.refs.firstname.validate();
        var validSurname = this.refs.surname.validate();
        var validGender = this.refs.gender.validate();
        var validBirth = this.refs.birth.validate();
        var validEmail = this.refs.email.validate();
        var validConfirmEmail = this.refs.confirmEmail.validate();
        var validAddress = this.refs.address.validate();
        var validZipCode = this.refs.zipcode.validate();
        var validCity = this.refs.city.validate();
        var validCountry = this.refs.country.validate();
        var validPhone = this.refs.phone.validate();

        return validFirstname && validSurname &&
               validGender && validBirth &&
               validEmail && validConfirmEmail &&
               validAddress && validZipCode &&
               validCity && validCountry && validPhone;
    }
});

module.exports = PersonalData;


// WEBPACK FOOTER //
// ./app/components/PersonalData.js